import React from 'react';
import { useTranslation } from 'react-i18next';

interface RequiredFieldIndicatorProps {
  label: string;
  required?: boolean;
  ariaLabelKey?: string;
}

const RequiredFieldIndicator: React.FC<RequiredFieldIndicatorProps> = ({
  label,
  required = true,
  ariaLabelKey = 'common.requiredField'
}) => {
  const { t } = useTranslation('common');

  return (
    <span className="inline-flex items-center">
      {label}
      {required && (
        <span className="ml-1 text-red-500 font-medium" aria-label={t(ariaLabelKey)}>
          *
        </span>
      )}
    </span>
  );
};

export default RequiredFieldIndicator;